import { api } from '../api'

export const dictionariesApi = api
  .enhanceEndpoints({
    addTagTypes: [
      'dictionaries',
      'projectType',
      'taskType',
      'flow',
      'genders',
      'passboltFolder',
      'project_scope_type',
    ],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getProjectType: builder.query({
        providesTags: ['projectType'],
        query: () => {
          return {
            url: `/project_type`,
            method: 'GET',
          }
        },
        transformResponse: (response) => response?.data || [],
      }),
      getTaskType: builder.query({
        providesTags: ['taskType'],
        query: () => {
          return {
            url: `/task_type`,
            method: 'GET',
          }
        },
        transformResponse: (response) => response?.data || [],
      }),
      getFlow: builder.query({
        providesTags: ['flow'],
        query: () => {
          return {
            url: `/flow`,
            method: 'GET',
          }
        },
        transformResponse: (response) => response?.data || [],
      }),
      getGenders: builder.query({
        providesTags: ['genders'],
        query: () => {
          return {
            url: '/gender',
            method: 'get',
          }
        },
        transformResponse: (response) => response?.data || [],
      }),
      getTags: builder.query({
        providesTags: ['tags'],
        query: () => {
          return {
            url: '/tag',
            method: 'get',
          }
        },
        transformResponse: (response) => response?.data || [],
      }),
      getPassboltFolder: builder.query({
        providesTags: ['passboltFolder'],
        query: () => {
          return {
            url: '/passbolt/folder',
            method: 'get',
          }
        },
        transformResponse: (response) => response?.data || [],
      }),
      getProjectScopeTypes: builder.query({
        providesTags: ['project_scope_type'],
        query: () => ({
          url: '/project_scope_type',
          method: 'get',
        }),
        transformResponse: (response) => response?.data || [],
      }),
    }),
  })

export const {
  useGetProjectTypeQuery,
  useGetTaskTypeQuery,
  useGetFlowQuery,
  useGetTagsQuery,
  useGetGendersQuery,
  useGetPassboltFolderQuery,
  useGetProjectScopeTypesQuery,
} = dictionariesApi
